// extracted by mini-css-extract-plugin
export default {"menu":"ConsultationExportMenu_menu__5Suov","menuList":"ConsultationExportMenu_menuList__VTj30","menuItem":"ConsultationExportMenu_menuItem__F7PoS"};